import React from 'react';
import type { CSS } from '@components-shared/src/stitches';
import { styled } from '@components-shared/src/stitches';

export const ErrorMessage = styled('div', {
  position: 'relative',
  fontFamily: '$base',
  fontWeight: 400,
  color: '$destructive700',
  fontSize: 12,

  '@tablet': {
    fontSize: 14,
  },
});

export const ErrorMessageAbsolutePosition = ({
  children,
  css,
  testId,
}: {
  children: React.ReactChild;
  css?: CSS;
  testId?: string;
}) => (
  <Container data-testid={testId}>
    <ErrorMessageAbs css={css}>{children}</ErrorMessageAbs>
  </Container>
);

const Container = styled('div', {
  position: 'relative',
});

export const ErrorMessageAbs = styled('div', {
  bottom: -10,
  position: 'absolute',
  fontFamily: '$base',
  fontWeight: 400,
  color: '$destructive700',
  textAlign: 'right',
  fontSize: 11,
});
